import { useMemo } from 'react';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'next-i18next';

import { JobShifts } from '../../legacy/job-shifts';

import { formatPartTimeWeeklyHours } from '../../../lib/job-position/part-time-weekly-hours';

import { jobPositionApiDataAtom } from '../job-position.atoms';
import { JobApplicationEntryPoint } from '../job-application-entry-point';

export const Shifts = () => {
  const { jobShiftsArgs, isEmptyEl } = useShifts();
  return !isEmptyEl ? (
    <>
      <JobShifts {...jobShiftsArgs}>
        <JobApplicationEntryPoint />
      </JobShifts>
      <hr className="text-gray-300" />
    </>
  ) : null;
};
const useShifts = () => {
  const jobPositionApiData = useAtomValue(jobPositionApiDataAtom);
  const { t } = useTranslation('common');

  // The decision to show the weekly hours, and their wording, belong here and
  // not in the legacy presentation component: that one renders what it is
  // given. It receives a finished string or nothing.
  const partTimeWeeklyHours = useMemo(
    () =>
      formatPartTimeWeeklyHours(
        jobPositionApiData?.part_time_weekly_hours,
        jobPositionApiData?.job_type_var?.key,
        (hours) => t('part_time_weekly_hours', { hours })
      ),
    [jobPositionApiData?.part_time_weekly_hours, jobPositionApiData?.job_type_var?.key, t]
  );

  const jobShiftsArgs = useMemo(
    () => ({
      jobType: jobPositionApiData?.job_type_var?.label || null,
      daysRequiredPerWeek: jobPositionApiData?.days_required_per_week,
      daysRequiredPerWeekNumber: jobPositionApiData?.days_required_per_week_number,
      shifts: jobPositionApiData?.shifts,
      shiftNotes: jobPositionApiData?.shift_notes,
      partTimeWeeklyHours,
      // customerServiceHelper: jobPositionApiData?.assigned_to_user?.name,
    }),
    [
      // jobPositionApiData?.assigned_to_user?.name,
      jobPositionApiData?.days_required_per_week,
      jobPositionApiData?.days_required_per_week_number,
      jobPositionApiData?.job_type_var?.label,
      jobPositionApiData?.shift_notes,
      jobPositionApiData?.shifts,
      partTimeWeeklyHours,
    ]
  );
  // The weekly hours count towards emptiness too. Without this the block would
  // still be hidden on an ad whose only schedule information IS the hours, and
  // the rule "show the hours when we have them" would quietly not hold.
  const isEmptyEl = useMemo(
    () =>
      Boolean(
        !jobPositionApiData?.days_required_per_week?.length &&
          !jobPositionApiData?.days_required_per_week_number &&
          !jobPositionApiData?.shifts?.length &&
          !partTimeWeeklyHours
      ),
    [
      jobPositionApiData?.days_required_per_week?.length,
      jobPositionApiData?.days_required_per_week_number,
      jobPositionApiData?.shifts?.length,
      partTimeWeeklyHours,
    ]
  );
  return { jobShiftsArgs, isEmptyEl };
};
